import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BarProfitInput from './BarProfitInput/BarProfitInput'
import BarProfitReport from './BarProfitReport/BarProfitReport'

export default class BarProfitTool extends Component {


    getDataIdQueryParameterFromUrlString(urlString) {
        let dataId;

        // get dataId query parameter string
        // Match until you can't on UUID for data-id. No further enforcement b/c
        // an email was sent out ~9/13-9/16 with a paren that get's parsed into the end of the id.
        var results = new RegExp("[?&]data-id(=([a-f\-0-9]*))").exec(urlString);
        if (!results) {
            dataId = null;
        } else if (!results[2]) {
            dataId = '';
        } else {
            dataId = decodeURIComponent(results[2].replace(/\+/g, " "));
        }

        return dataId;
    }

    constructor(props, context) {
        super(props, context);

        this.state = {
            dataId: this.getDataIdQueryParameterFromUrlString(window.location.href)
        };
    };

    render() {
        return (
            this.state.dataId === null ?
                <BarProfitInput /> : <BarProfitReport dataId={ this.state.dataId } />
        );
    }
}

BarProfitTool.propTypes = {
};
